import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {PostInvoicePdf, PostInvoicePdfModel, PostInvoicePdfParams} from 'domain/usecases';

export class RemotePostInvoicePdf implements PostInvoicePdf {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostInvoicePdfModel>,
	) {}

	async post({signal, ...body}: PostInvoicePdfParams): Promise<PostInvoicePdfModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			responseType: 'blob',
			body,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
